/* ============================================================
   LGX theme
   Every interaction from the original build, wired to Shopify.
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.LGX || {};
  var routes = CFG.routes || {};
  var strings = {
    added: "Added to your order",
    reserved: "Reserved . 50 percent to hold",
    soldOut: "Sold out",
    addToCart: "Add to cart",
    unavailable: "Unavailable",
    error: "That could not be added. Please try again."
  };

  function el(id) { return document.getElementById(id); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || CFG.moneyFormat || "${{amount}}";
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var frac = parts[1] ? decimal + parts[1] : "";
      return whole + frac;
    }

    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case "amount": value = num(cents, 2); break;
      case "amount_no_decimals": value = num(cents, 0); break;
      case "amount_with_comma_separator": value = num(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = num(cents, 2, "'", "."); break;
      case "amount_no_decimals_with_space_separator": value = num(cents, 0, " "); break;
      case "amount_with_space_separator": value = num(cents, 2, " ", ","); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(message) {
    var t = el("toast");
    if (!t) return;
    t.textContent = message;
    t.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("on"); }, 2200);
  }

  /* ---------- whatsapp ---------- */
  function waLink(text) {
    var number = (CFG.whatsapp || "").replace(/[^0-9]/g, "");
    if (!number) return null;
    return "https://wa.me/" + number + "?text=" + encodeURIComponent(text);
  }
  function openWa(text) {
    var url = waLink(text);
    if (url) window.open(url, "_blank", "noopener");
  }

  /* ---------- cart ---------- */
  function setCount(count) {
    var badge = el("bagCount");
    if (!badge) return;
    badge.textContent = count;
    if (count > 0) badge.removeAttribute("hidden");
    else badge.setAttribute("hidden", "");
  }

  function openDrawer() {
    var d = el("cartDrawer");
    if (!d) return;
    d.classList.add("on");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    var d = el("cartDrawer");
    if (!d) return;
    d.classList.remove("on");
    document.body.style.overflow = "";
  }

  /* Rebuild the drawer body straight from /cart.js, since a snippet
     cannot be re-rendered by the Section Rendering API. */
  function renderCart(cart) {
    setCount(cart.item_count);

    var total = el("cartTotal");
    if (total) total.textContent = formatMoney(cart.total_price);

    var checkout = document.querySelector(".cd__go");
    if (checkout) checkout.disabled = cart.item_count === 0;

    var body = el("cartBody");
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="cd__empty">Your order is empty.</p>';
      return;
    }

    function esc(v) {
      return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function sized(url) {
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=200";
    }

    body.innerHTML = cart.items.map(function (line) {
      var img = line.image
        ? '<img src="' + esc(sized(line.image)) + '" alt="" width="200" height="200" loading="lazy">'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="#9AA39C" stroke-width="1.5"><path d="M3 7 12 3l9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/></svg>';

      var vendor = line.vendor ? '<span class="ci__brand">' + esc(line.vendor) + "</span>" : "";
      var variant = line.variant_title ? '<span class="ci__v">' + esc(line.variant_title) + "</span>" : "";
      var deal = line.properties && line.properties._Deal ? '<span class="ci__v ci__deal">' + esc(line.properties._Deal) + "</span>" : "";

      return (
        '<div class="ci" data-line-key="' + esc(line.key) + '">' +
          '<a class="ci__img" href="' + esc(line.url) + '">' + img + "</a>" +
          "<div>" + vendor +
            '<div class="ci__n"><a href="' + esc(line.url) + '">' + esc(line.product_title) + "</a></div>" + variant + deal +
            '<div class="ci__ctrl">' +
              '<div class="qty">' +
                '<button type="button" data-q="-1" aria-label="Decrease">&minus;</button>' +
                '<input type="number" value="' + line.quantity + '" min="0" aria-label="Quantity">' +
                '<button type="button" data-q="1" aria-label="Increase">+</button>' +
              "</div>" +
              '<button type="button" class="ci__rm" data-remove="' + esc(line.key) + '">Remove</button>' +
            "</div>" +
          "</div>" +
          '<div class="ci__p">' + formatMoney(line.final_line_price) + "</div>" +
        "</div>"
      );
    }).join("");
  }

  function refreshCount() {
    return fetch(routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function addToCart(id, quantity, onDone) {
    return fetch(routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || strings.error);
          return data;
        });
      })
      .then(function (data) {
        return refreshCount().then(function () {
          openDrawer();
          if (onDone) onDone(null, data);
          return data;
        });
      })
      .catch(function (err) {
        if (onDone) onDone(err);
        toast(err.message || strings.error || "Something went wrong");
      });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  /* ---------- product tabs ---------- */
  function switchTab(id) {
    all("[data-tab]").forEach(function (b) {
      var on = b.getAttribute("data-tab") === id;
      b.classList.toggle("on", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    all("[data-panel]").forEach(function (p) {
      if (p.getAttribute("data-panel") === id) p.removeAttribute("hidden");
      else p.setAttribute("hidden", "");
    });
  }

  /* ---------- reviews ---------- */
  var reviewState = { filter: "all", format: "wall" };

  function paintReviews() {
    all("[data-format]").forEach(function (wrap) {
      if (wrap.getAttribute("data-format") === reviewState.format) wrap.removeAttribute("hidden");
      else wrap.setAttribute("hidden", "");
    });

    var visible = document.querySelector('[data-format="' + reviewState.format + '"]');
    if (!visible) return;

    var step = 0;
    var more = el("revMore");
    if (more) step = parseInt(more.getAttribute("data-step"), 10) || 0;
    var shown = 0;

    all(".rv, .rq", visible).forEach(function (card) {
      var src = card.getAttribute("data-src");
      var match =
        reviewState.filter === "all" ||
        (reviewState.filter === "issues" && card.hasAttribute("data-issue")) ||
        src === reviewState.filter;

      if (match && (step === 0 || shown < step || reviewState.expanded)) {
        card.style.display = "";
        shown++;
      } else {
        card.style.display = "none";
      }
    });

    if (more) {
      var total = all(".rv, .rq", visible).filter(function (c) {
        var src = c.getAttribute("data-src");
        return (
          reviewState.filter === "all" ||
          (reviewState.filter === "issues" && c.hasAttribute("data-issue")) ||
          src === reviewState.filter
        );
      }).length;
      more.style.display = !reviewState.expanded && total > step && step > 0 ? "" : "none";
    }
  }

  /* ---------- lightbox ---------- */
  function openLightbox(trigger) {
    var box = el("rvlb");
    var body = el("rvlbC");
    if (!box || !body) return;

    var type = trigger.getAttribute("data-lb-type");
    var src = trigger.getAttribute("data-lb-src");
    var poster = trigger.getAttribute("data-lb-poster");

    if (type === "video" && src) {
      body.innerHTML =
        '<video src="' + src + '" controls autoplay playsinline' + (poster ? ' poster="' + poster + '"' : "") + "></video>";
    } else if (type === "image" && src) {
      body.innerHTML = '<img src="' + src + '" alt="">';
    } else {
      var faux = trigger.querySelector(".faux");
      if (faux) body.innerHTML = '<div style="background:#fff">' + faux.outerHTML + "</div>";
      else {
        var ref = trigger.getAttribute("data-lb-ref");
        var source = ref ? document.querySelector('.shot[data-lb="' + ref + '"] .faux') : null;
        body.innerHTML = source ? '<div style="background:#fff">' + source.outerHTML + "</div>" : "";
      }
    }
    box.classList.add("on");
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    var box = el("rvlb");
    var body = el("rvlbC");
    if (!box) return;
    if (body) body.innerHTML = "";
    box.classList.remove("on");
    document.body.style.overflow = "";
  }

  /* ---------- product page ---------- */
  var variants = null;
  var selected = [];

  function readVariants() {
    var node = el("pdpVariants");
    if (!node) return;
    try { variants = JSON.parse(node.textContent); } catch (e) { variants = null; }
    if (!variants) return;

    all(".pdp__sw").forEach(function (group, i) {
      var on = group.querySelector("button.on") || group.querySelector("button");
      selected[i] = on ? on.getAttribute("data-value") : null;
    });
  }

  function findVariant() {
    if (!variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j] != null && v.options[j] !== selected[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant() {
    var v = findVariant();
    var idField = el("pdpVariantId");
    var addBtn = el("pdpAdd");
    var price = el("pdpPrice");
    var compare = el("pdpCompare");
    var barPrice = el("pdpBarPrice");
    var stock = el("pdpStock");
    var barBtn = document.querySelector('.pdp__bar .btn--buy');

    if (!v) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable || "Unavailable"; }
      if (barBtn) { barBtn.disabled = true; barBtn.textContent = strings.unavailable || "Unavailable"; }
      return;
    }

    if (idField) idField.value = v.id;
    if (price) price.textContent = formatMoney(v.price);
    if (barPrice) barPrice.textContent = formatMoney(v.price);

    if (compare) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compare.textContent = formatMoney(v.compare_at_price);
        compare.style.display = "";
      } else {
        compare.style.display = "none";
      }
    }

    if (stock && v.available && v.inventory_management && v.inventory_quantity > 0) {
      stock.classList.toggle("low", v.inventory_quantity <= 5);
    }

    var label = v.available ? strings.addToCart : strings.soldOut;
    if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = label; }
    if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = label; }

    if (v.featured_image && v.featured_image.src) {
      var main = el("pdpMainImg");
      if (main) main.src = v.featured_image.src;
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());
    }

    var wa = document.querySelector("[data-waproduct]");
    if (wa) wa.setAttribute("data-price", formatMoney(v.price));
  }

  function qtyValue() {
    var input = el("pdpQty");
    return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
  }

  /* ---------- pc order + custom order state ---------- */
  var pcPick = { budget: "", use: "" };

  /* ============================================================
     EVENTS
     ============================================================ */
  document.addEventListener("click", function (e) {
    var x;

    /* burger */
    if (e.target.closest("#burger")) {
      var nav = el("mnav");
      var burger = el("burger");
      if (nav) {
        var open = nav.classList.toggle("is-open");
        if (burger) burger.setAttribute("aria-expanded", open ? "true" : "false");
      }
      return;
    }

    /* cart drawer */
    if (e.target.closest("#cartToggle")) {
      e.preventDefault();
      refreshCount();
      openDrawer();
      return;
    }
    if (e.target.closest("[data-cart-close]")) {
      closeDrawer();
      return;
    }

    /* search toggle */
    if (e.target.closest("#srchToggle")) {
      var panel = el("srch");
      var toggle = el("srchToggle");
      if (panel) {
        var isOpen = panel.classList.toggle("is-open");
        if (toggle) toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        if (isOpen) {
          var field = panel.querySelector("input[type=search]");
          if (field) field.focus();
        }
      }
      return;
    }

    /* tabs */
    if ((x = e.target.closest("[data-tab]"))) {
      switchTab(x.getAttribute("data-tab"));
      return;
    }

    /* card colour dots, purely visual on the grid */
    if ((x = e.target.closest(".pc__sw [data-col]"))) {
      e.preventDefault();
      e.stopPropagation();
      all("button", x.parentNode).forEach(function (b) { b.classList.remove("on"); });
      x.classList.add("on");
      return;
    }

    /* quick add */
    if ((x = e.target.closest("[data-add]"))) {
      e.preventDefault();
      e.stopPropagation();
      if (x.getAttribute("data-needs-options") === "true") {
        window.location.href = x.getAttribute("data-url");
        return;
      }
      var id = x.getAttribute("data-add");
      var isPre = x.getAttribute("data-pre") === "true";
      var label = x.textContent;
      x.disabled = true;
      addToCart(id, 1, function (err) {
        x.disabled = false;
        x.textContent = label;
        if (!err) toast(isPre ? strings.reserved : strings.added);
      });
      return;
    }

    /* open product from card body */
    if ((x = e.target.closest("[data-open]"))) {
      if (e.target.closest("a") || e.target.closest("button")) return;
      window.location.href = x.getAttribute("data-open");
      return;
    }

    /* review filters */
    if ((x = e.target.closest("[data-rf]"))) {
      reviewState.filter = x.getAttribute("data-rf");
      reviewState.expanded = false;
      all("[data-rf]").forEach(function (b) { b.classList.remove("on"); });
      x.classList.add("on");
      paintReviews();
      return;
    }

    /* review format */
    if ((x = e.target.closest("[data-rfmt]"))) {
      reviewState.format = x.getAttribute("data-rfmt");
      all("[data-rfmt]").forEach(function (b) { b.classList.remove("on"); });
      x.classList.add("on");
      paintReviews();
      return;
    }

    /* review load more */
    if (e.target.closest("#revMore")) {
      reviewState.expanded = true;
      paintReviews();
      return;
    }

    /* lightbox */
    if ((x = e.target.closest("[data-lb]"))) {
      openLightbox(x);
      return;
    }
    if (e.target.closest("#rvlbX")) { closeLightbox(); return; }
    if (e.target.id === "rvlb") { closeLightbox(); return; }

    /* pdp thumbs */
    if ((x = e.target.closest("[data-shot]"))) {
      all(".gal__t").forEach(function (b) { b.classList.remove("on"); });
      x.classList.add("on");
      var full = x.getAttribute("data-full");
      var mainImg = el("pdpMainImg");
      if (full && mainImg) mainImg.src = full;
      return;
    }

    /* pdp options */
    if ((x = e.target.closest(".pdp__sw [data-opt]"))) {
      var index = parseInt(x.getAttribute("data-opt"), 10);
      selected[index] = x.getAttribute("data-value");
      all("button", x.parentNode).forEach(function (b) { b.classList.remove("on"); });
      x.classList.add("on");
      updateVariant();
      return;
    }

    /* quantity */
    if ((x = e.target.closest("[data-q]"))) {
      var input = x.parentNode.querySelector("input");
      if (input) {
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(x.getAttribute("data-q"), 10));
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }

    /* accordion */
    if ((x = e.target.closest("[data-acc]"))) {
      var item = x.parentNode;
      var isOpen = item.classList.toggle("open");
      x.setAttribute("aria-expanded", isOpen ? "true" : "false");
      var sign = x.querySelector("i");
      if (sign) sign.textContent = isOpen ? "\u2212" : "+";
      return;
    }

    /* whatsapp, product */
    if ((x = e.target.closest("[data-waproduct]"))) {
      e.preventDefault();
      var parts = [];
      all(".pdp__sw").forEach(function (group, i) {
        var on = group.querySelector("button.on");
        if (on) parts.push(on.getAttribute("data-value"));
      });
      var title = x.getAttribute("data-vendor")
        ? x.getAttribute("data-vendor") + " " + x.getAttribute("data-title")
        : x.getAttribute("data-title");
      openWa(
        "Hello, I want to order:\n" +
          title +
          (parts.length ? " (" + parts.join(", ") + ")" : "") +
          " x" + qtyValue() +
          "\nPrice: " + x.getAttribute("data-price")
      );
      return;
    }

    /* custom order chips */
    if ((x = e.target.closest("[data-cchip]"))) {
      var value = x.getAttribute("data-cchip");
      all("[data-cchip]").forEach(function (c) { c.classList.remove("on"); });
      x.classList.add("on");
      var what = el("custWhat");
      if (what) {
        what.value = /something else/i.test(value) ? "" : value + ", ";
        what.focus();
      }
      return;
    }

    /* custom order submit */
    if (e.target.closest("#custGo")) {
      var whatField = el("custWhat");
      var cityField = el("custCity");
      var what = whatField ? whatField.value.trim() : "";
      var city = cityField ? cityField.value.trim() : "";
      if (!what) { if (whatField) whatField.focus(); return; }
      openWa(
        "Hello, can you source this for the next shipment:\n" + what +
        (city ? "\n\nCity: " + city : "") +
        "\n\nWhat would the landed price and timeline be?"
      );
      return;
    }

    /* pc budget */
    if ((x = e.target.closest("[data-pcb]"))) {
      pcPick.budget = x.getAttribute("data-pcb");
      all("[data-pcb]").forEach(function (c) { c.classList.remove("on"); });
      x.classList.add("on");
      return;
    }

    /* pc use */
    if ((x = e.target.closest("[data-pcu]"))) {
      pcPick.use = x.getAttribute("data-pcu");
      all("[data-pcu]").forEach(function (c) { c.classList.remove("on"); });
      x.classList.add("on");
      return;
    }

    /* pc submit */
    if (e.target.closest("#pcGo")) {
      var pcCity = el("pcCity");
      var cityValue = pcCity ? pcCity.value.trim() : "";
      openWa(
        "Hello, I want a PC build quote." +
          (pcPick.budget ? "\n\nBudget: " + pcPick.budget : "") +
          (pcPick.use ? "\nMainly for: " + pcPick.use : "") +
          (cityValue ? "\nCity: " + cityValue : "") +
          "\n\nCan you send a parts list?"
      );
      return;
    }

    /* generic whatsapp */
    if ((x = e.target.closest("[data-wa]"))) {
      e.preventDefault();
      openWa("Hello, ");
      return;
    }

    /* cart line removal */
    if ((x = e.target.closest("[data-remove]"))) {
      e.preventDefault();
      changeLine(x.getAttribute("data-remove"), 0);
      return;
    }
  });

  /* cart quantity inputs */
  document.addEventListener("change", function (e) {
    var line = e.target.closest("[data-line-key]");
    if (line && e.target.matches("input[type=number]")) {
      var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      changeLine(line.getAttribute("data-line-key"), qty);
    }
  });

  /* add to cart form */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("#pdpForm");
    if (!form) return;
    e.preventDefault();

    var idField = el("pdpVariantId");
    var button = el("pdpAdd");
    if (!idField) return;

    var label = button ? button.textContent : "";
    if (button) { button.setAttribute("aria-busy", "true"); button.disabled = true; }

    addToCart(idField.value, qtyValue(), function (err) {
      if (button) {
        button.removeAttribute("aria-busy");
        button.disabled = false;
        button.textContent = label;
      }
      if (!err) toast(strings.added);
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeLightbox();
      closeDrawer();
    }
  });

  /* ---------- boot ---------- */
  function boot() {
    readVariants();
    paintReviews();
    setCount(CFG.cartCount || 0);

    /* autoplay guard for browsers that block it silently */
    all("video[autoplay]").forEach(function (v) {
      var play = v.play();
      if (play && play.catch) play.catch(function () {});
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  /* theme editor hooks */
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();
